import { FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../../base/hooks";
import { IDateTimeProps } from "./IDateTimeProps";

export const DateTimeProperties = [
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    { id: Property.Placeholder, name: 'Placeholder', type: PropertyType.String },
    { id: Property.Required, name: 'Required', type: PropertyType.Boolean },
    { id: Property.Readonly, name: 'Readonly', type: PropertyType.Boolean },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Min, name: 'Min. Value', type: PropertyType.DateTime },
    { id: Property.Max, name: 'Max. Value', type: PropertyType.DateTime },
]

export const useDateTimeProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IDateTimeProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: IDateTimeProps = {
            label: bindings.getValue(Property.Label) || '',
            title: bindings.getValue(Property.Tooltip) || '',
            placeholder: bindings.getValue(Property.Placeholder) || '',
            value: bindings.getValue(Property.InitValue) || '',
            required: bindings.getValue(Property.Required) || false,
            readOnly: bindings.getValue(Property.Readonly) || false,
            disabled: bindings.getValue(Property.Disabled) || false,
            min: bindings.getValue(Property.Min),
            max: bindings.getValue(Property.Max),
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}